import { SelectBox } from 'devextreme-react';
import React from 'react';
import { FormGroup } from 'reactstrap';

const ReportTypeSelector = React.memo(({
    reportOptions,
    selectedReport,
    isGenerating,
    onReportChange
}) => {
    // Seçili raporun durumunu kontrol et
    const selectedReportInfo = reportOptions.find(opt => opt.id === selectedReport);
    const isSelectedReportInactive = selectedReport !== null && selectedReport !== undefined &&
        (selectedReport === 0 || (selectedReportInfo && selectedReportInfo.id === null));

    return (
        <FormGroup className="mb-0" style={{ position: 'relative' }}>
            <label className="form-label" style={{ fontSize: '14px' }}>
                Rapor Türü
            </label>
            <SelectBox
                dataSource={reportOptions}
                displayExpr="name"
                valueExpr="id"
                placeholder="Seçiniz"
                value={selectedReport}
                onValueChanged={onReportChange}
                searchEnabled={true}
                showClearButton={true}
                height={40}
                disabled={isGenerating}
            />
            {isSelectedReportInactive && (
                <small
                    className="text-danger"
                    style={{
                        fontSize: '11px',
                        position: 'absolute',
                        top: '100%',
                        left: '0',
                        zIndex: 10,
                        backgroundColor: '#fff',
                        padding: '2px 4px',
                        borderRadius: '3px',
                        border: '1px solid #dc3545',
                        whiteSpace: 'nowrap'
                    }}
                >
                    ⚠️ Bu rapor aktif değildir
                </small>
            )}
        </FormGroup>
    );
});

export default ReportTypeSelector; 